import { fetchGet, fetchPost } from '~shared/util/fetchUtil'
import { getAuthToken, getRequestAuthOptions } from '~shared/util/authUtil'
import type { KdsConfigResponse } from '../Types/Types'
import type { KdsLockStateRequest } from '../Types/KdsLock'
import type { SiteHealth } from '../Types/SiteHealth'

// Read the env var directly (rather than via GlobalStore) to avoid GlobalStore -> Service -> GlobalStore
const apiUrl = import.meta.env.VITE_API_URL as string

// Raw, pre-normalization shape -- callers apply normalizeKdsConfig to derive actionPolicy.
export async function fetchConfig(): Promise<KdsConfigResponse> {
  return fetchGet<KdsConfigResponse>(`${apiUrl}/kds/orders/config`, { token: getAuthToken() })
}

export async function recordHeartbeat(): Promise<void> {
  await fetchPost(`${apiUrl}/api/kds/devices/heartbeat`, undefined, {
    token: getAuthToken(),
    skipAuthRefresh: true,
  })
}

export async function recordLockState(isLocked: boolean, stepUpToken?: string): Promise<void> {
  const request: KdsLockStateRequest = { isLocked }
  await fetchPost(`${apiUrl}/kds/lock/audit`, request, {
    ...getRequestAuthOptions(stepUpToken),
    skipAuthRefresh: true,
  })
}

export async function fetchSiteHealth(): Promise<SiteHealth> {
  return fetchPost<SiteHealth>(`${apiUrl}/kds/sitehealth`, undefined, { token: getAuthToken() })
}
